var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import DataForm from "~/components/common/data-form.vue";
import DetailedInfoQuery from "./detailed-info-query.vue";
import { Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { CollectionCaseService } from "~/services/domain-service/collection-case.service";
var collectionManageModule = namespace("collection-manage");
var MultiPositionQuery = /** @class */ (function (_super) {
    __extends(MultiPositionQuery, _super);
    function MultiPositionQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.detailsCaseId = "";
        _this.loading = {
            state: false
        };
        _this.dialog = {
            detailedInfoQuery: false
        };
        _this.dataSet = [];
        return _this;
    }
    MultiPositionQuery.prototype.created = function () { };
    MultiPositionQuery.prototype.mounted = function () {
        this.refreshData();
    };
    MultiPositionQuery.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        var queryModel = { caseId: this.caseId };
        this.collectionCaseService
            .multidimensionalPositioning(queryModel, this.loading)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    __decorate([
        Dependencies(CollectionCaseService)
    ], MultiPositionQuery.prototype, "collectionCaseService", void 0);
    __decorate([
        Prop()
    ], MultiPositionQuery.prototype, "caseId", void 0);
    MultiPositionQuery = __decorate([
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                DetailedInfoQuery: DetailedInfoQuery
            }
        })
    ], MultiPositionQuery);
    return MultiPositionQuery;
}(Vue));
export default MultiPositionQuery;
